<template>
  <div class="card-body px-0 pt-0 pb-3">
    <div class="table-responsive">
      <el-table border :data="hearings" class="el-table-css" size="default" style="width: 100%">
        <!-- Tarix -->
        <el-table-column label="Tarix">
          <template #default="scope">
            {{ formatDate(scope.row.hearingDate) }}
          </template>
        </el-table-column>
        <el-table-column label="Saat">
          <template #default="scope">
            {{ formatTime(scope.row.hearingDate) }}
          </template>
        </el-table-column>
        <el-table-column prop="address" label="Ünvan" />
        <el-table-column prop="notes" label="Qeydlər" />
        <el-table-column width="80" fixed="right">
          <template #default="scope">
              <el-button class="fs-5" type="text" style="padding: 0px;" :disabled="status === 50" :icon="Edit"
                title="Düzəliş et" @click="$emit('edit-hearing', scope.row)">
              </el-button>
              <el-button class="fs-5" type="danger" style="padding: 0 !important;" :icon="Delete" title="Sil"
                :disabled="status === 50" text @click="$emit('delete-court-hearing', scope.row.id)">
              </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { Edit, Delete } from "@element-plus/icons-vue";
export default {
  props: {
    hearings: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      Edit,
      Delete,
    };
  },
  methods: {
    formatDate(datetime) {
      if (!datetime) return "-";
      const d = new Date(datetime);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      return `${day}.${month}.${year}`;
    },
    formatTime(datetime) {
      if (!datetime) return "-";
      const d = new Date(datetime);
      const hours = String(d.getHours()).padStart(2, "0");
      const minutes = String(d.getMinutes()).padStart(2, "0");
      return `${hours}:${minutes}`;
    },
  },
};
</script>

<style scoped>
.table-responsive {
  overflow-x: auto;
}
</style>
